import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse, LogErrorInterface, PlaceDetails } from '@/interfaces';

class Commons {
	constructor(private client: AxiosInstance) {}

	async getAutompletePlaces(term: string): Promise<HttpResponse<any[]>> {
		return this.client.get(`/commons/autocomplete-places?term=${term}`);
	}

	async getPlaceDetails(placeId: string): Promise<HttpResponse<PlaceDetails>> {
		return this.client.get(`/commons/place-details/${placeId}`);
	}

	async postLogError(
		data: LogErrorInterface
	): Promise<HttpResponse<LogErrorInterface>> {
		return this.client.post('/commons/log-error', data);
	}
}

export const commonsService = new Commons(axiosClient);
